import { useTranslations } from '@aikoa/i18n/react'
import { useMutation } from '@tanstack/react-query'
import { useRouter } from 'expo-router'
import { useState } from 'react'
import { View } from 'react-native'
import { OrganisationFormFields } from '~/components/admin/OrganisationFormFields'
import ContentBox from '~/components/layout/ContentBox'
import ScreenView from '~/components/layout/ScreenView'
import { Body } from '~/components/typography/Content'
import { Heading2 } from '~/components/typography/Titles'
import { Button, ButtonLabel } from '~/components/ui/button'
import { queryClient, trpcClient } from '~/lib/trpc'

export default function AddOrganisation() {
  const { t } = useTranslations('admin')
  const router = useRouter()

  const [name, setName] = useState('')
  const [emailDomain, setEmailDomain] = useState('')

  const createMutation = useMutation({
    mutationFn: async () => {
      return await trpcClient.admin.createOrganisation.mutate({
        name,
        emailDomain,
      })
    },
    onSuccess: (data) => {
      void queryClient.invalidateQueries({
        queryKey: ['admin', 'listOrganisations'],
      })
      router.replace(`/(authenticated)/admin/organisations/${data.id}`)
    },
  })

  const isValid = name.trim().length > 0 && emailDomain.trim().length > 0

  return (
    <ScreenView>
      <ContentBox className="flex-1" contentContainerClassName="gap-6" variant="transparent">
        <View className="gap-4">
          <Heading2 className="text-center">{t(($) => $.organisations.create.title)}</Heading2>
          <Body className="text-center text-neutral-600">
            {t(($) => $.organisations.create.description)}
          </Body>
        </View>

        <View className="gap-6">
          <OrganisationFormFields
            name={name}
            onNameChange={setName}
            emailDomain={emailDomain}
            onEmailDomainChange={setEmailDomain}
            showDomainField
          />

          <Button
            variant="primary"
            size="lg"
            disabled={!isValid || createMutation.isPending}
            onPress={() => createMutation.mutate()}>
            <ButtonLabel>
              {createMutation.isPending
                ? t(($) => $.organisations.create.buttonLoading)
                : t(($) => $.organisations.create.button)}
            </ButtonLabel>
          </Button>

          {!!createMutation.error && (
            <Body className="text-center text-destructive">
              {t(($) => $.organisations.create.error)}
            </Body>
          )}
        </View>
      </ContentBox>
    </ScreenView>
  )
}
